export default __webpack_public_path__ + "static/media/sns-kakao.d2415671.svg";